import { render } from "./ViewMiddle.vue?vue&type=template&id=642756b7"
import script from "./ViewMiddle.vue?vue&type=script&lang=js"
export * from "./ViewMiddle.vue?vue&type=script&lang=js"

import "./ViewMiddle.vue?vue&type=style&index=0&id=642756b7&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__